

/// <reference path="InvitationRule.ts" />

// Generated class GenericInvitationRule_ManagedObject

class GenericInvitationRule_ManagedObject extends InvitationRule
{
}
